import { NgModule } from '@angular/core';
import { GsapRevealDirective } from './directives/gsap-reveal.directive';
import { RippleDirective } from './directives/ripple.directive';
import { TiltHoverDirective } from './directives/tilt-hover.directive';

@NgModule({
  imports: [GsapRevealDirective, RippleDirective, TiltHoverDirective],
  exports: [GsapRevealDirective, RippleDirective, TiltHoverDirective],
})
export class SharedModule {}
